import { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import { BASE_URL } from '../../utils/constants'

const Dropdown = styled.ul`
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 35;
  font-weight: 700;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.midnightBlue};
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.71);
  //border-bottom: ${(props) => `1px solid ${props.theme.colors.lightGray}`};
  transform: ${(props) =>
    props.open ? 'translateY(4.5rem)' : 'translateY(-15.5rem)'};
  transition: all 500ms ease;

  li {
    text-decoration: none;
    font-size: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    cursor: pointer;
    a {
      &:link {
        color: ${(props) => props.theme.colors.white};
      }

      &:hover {
        text-decoration: none;
      }
      &:visited {
        color: ${(props) => props.theme.colors.white};
      }
    }
  }
  ${Mq.sm} {
    top: 0;
    transform: ${(props) =>
      props.open ? 'translateY(3rem)' : 'translateY(-17rem)'};
  }
`

const DropDownMenu = ({ open, handleMobileOpen }) => {
  const { ui, setUi } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'

  const changeLang = () => {
    if (ui === 'en') setUi('fa')
    else if (ui === 'fa') setUi('en')
  }

  const uiLang = ui === 'fa' ? 'fa/' : ''

  return (
    <Dropdown open={open} dir={dir} onClick={handleMobileOpen}>
      <li onClick={changeLang}>{ui === 'en' ? 'فارسی' : 'English'}</li>
      <li>
        <a
          href={`${BASE_URL}/${uiLang}memorial`}
          target="_blank"
          rel="noreferrer"
        >
          {lang[ui]['Memorial']}
        </a>
      </li>

      <li>
        <a
          href={`${BASE_URL}/${uiLang}library`}
          target="_blank"
          rel="noreferrer"
        >
          {lang[ui]['Library']}
        </a>
      </li>
      <li>
        <a href={`${BASE_URL}/${uiLang}`} target="_blank" rel="noreferrer">
          {lang[ui]['Projects']}
        </a>
      </li>
      <li>
        <a
          href={`${BASE_URL}/${uiLang}center`}
          target="_blank"
          rel="noreferrer"
        >
          {lang[ui]['About']}
        </a>
      </li>
      <li>
        <a
          href={`${BASE_URL}/${uiLang}newsletter`}
          target="_blank"
          rel="noreferrer"
        >
          {lang[ui]['News']}
        </a>
      </li>
    </Dropdown>
  )
}
export default DropDownMenu

DropDownMenu.propTypes = {
  open: PropTypes.bool,
  handleMobileOpen: PropTypes.func
}
